import { render, staticRenderFns } from "./SaleServiceOrder.vue?vue&type=template&id=67f335c0&"
import script from "./SaleServiceOrder.vue?vue&type=script&lang=js&"
export * from "./SaleServiceOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports